import { AdjustmentType } from 'enums';
import { useDisputeType } from 'hooks';
import { 
    useRefreshAllDisputeSummaries, 
    useRefreshDeductionDetails, 
    useRefreshInvoiceDetails, 
    useRefreshPaymentDetails 
} from 'state';
import { AdjustmentDetail } from 'types';

export default function useRefreshOnDisputeCreated(disputeRows: AdjustmentDetail[]) {
    const firstRow = disputeRows[0];
    const { invoiceId, paymentIdRef, vendorId, accountId, customerItemReference, voucherId, adjustmentIdentityKey } = firstRow ?? {};
    const referenceId = firstRow?.adjustmentTypeId === AdjustmentType.CustomerDeduction
        ? customerItemReference
        : undefined;
    const refreshInvoice = useRefreshInvoiceDetails(accountId ?? '', vendorId ?? '', invoiceId ?? '');
    const refreshVoucherInvoice = useRefreshInvoiceDetails(accountId ?? '', vendorId ?? '', invoiceId ?? '', voucherId);
    const refreshPayment = useRefreshPaymentDetails(accountId ?? '', vendorId ?? '', paymentIdRef ?? '');
    const refreshDisputes = useRefreshAllDisputeSummaries();
    const refreshDeductionByInvoice = useRefreshDeductionDetails(accountId ?? '', vendorId ?? '', invoiceId ?? '');
    const refreshExactDeduction = useRefreshDeductionDetails(
        accountId ?? '',
        vendorId ?? '',
        invoiceId ?? '',
        referenceId,
        voucherId,
        adjustmentIdentityKey
    );
    const { isPayment, isInvoice } = useDisputeType(firstRow?.adjustmentTypeId ?? AdjustmentType.CustomerDeduction);
    
    return () => {
        if (!firstRow) {
            return;
        }
        if (isInvoice) {
            refreshInvoice();
            if (voucherId) {
                refreshVoucherInvoice();
            }
        }
        if (isPayment) {
            refreshDeductionByInvoice();
            if (referenceId || voucherId || adjustmentIdentityKey) {
                refreshExactDeduction();
            }
            refreshPayment();
        }
        refreshDisputes();
    };
};
